// React
import React from 'react';
// Styles
import './styles.scss';

/**
 * @param {Object} props.style - Style to applied to the component, this overwrites the height and width props
 * @param {string} props.className - className to applied to the component
 * @param {number} props.height - Height of the component
 * @param {number} props.width - Width of the component
 */
class ContainerRounded extends React.Component {
    constructor(props) {
        super(props);
        this.style = {};
        this.className = props.className ? props.className : '';
        if (props.height) this.style.height = this.height;
        if (props.width) this.style.width = this.width;
        if (props.style) this.style = { ...this.style, ...props.style };
    }

    render() {
        return (
            <div className={`container-rounded ${this.className}`} style={this.style}>
                {this.props.children}
            </div>
        );
    }
}

export default ContainerRounded;
